<div class="main-column">
	<app-hub-nav-header
		[sportCode]="sportCode"
		currentRoute="schedule"
	></app-hub-nav-header>
	<div class="page-description">
		<h1 class="page-title">{{sport?.shortName || (sportCode | uppercase)}} Predictions</h1>
		<app-page-intro-copy *ngIf="trustedDesc" [html]="trustedDesc"></app-page-intro-copy>
	</div>
	<app-swc-preview-banner *ngIf="(sportCode | uppercase) === 'SWC'"></app-swc-preview-banner>
	<!-- <app-pro-banner *ngIf="(sportCode | uppercase) === 'CBB'"></app-pro-banner> -->
	<app-match-list-block
		[configurationObject]="matchListConfig"
	></app-match-list-block>
	<app-odds-disclaimer *ngIf="environment.optionalFeatures.includes('odds-disclaimer')"></app-odds-disclaimer>
	<app-best-offers *ngIf="environment.optionalFeatures.includes('best-offers')" [sportCode]="sportCode"></app-best-offers>
	<app-display-ad type="main-column" *ngIf="(environment.googleAdsConfig?.adSpaces?.['main-column'] || environment.optionalFeatures.includes('placeholder-ads')) && trustedCopy" class="main-column-padding" [sportCode]="sportCode"></app-display-ad>
	<div class="description" *ngIf="trustedCopy">
		<span [innerHTML]="trustedCopy">
		</span>
	</div>
	<section class="faq" *ngIf="pageFaqs?.length > 0">
		<h2 class="heading">
			FAQ
		</h2>
		<div>
			<app-faq-container *ngFor="let question of pageFaqs" [headerText]="question.headerText"
				[bodyHTML]="question.bodyHTML"></app-faq-container>
		</div>
	</section>
</div>
<!-- Arbitrary margin on this page to cause heading of first element to align with first element of main column-->
<div class="sidebar" style="margin-top: 17px;">
	<app-display-ad type="articles-POS1" class="large-only" [largeOnly]="true" *ngIf="environment.googleAdsConfig?.adSpaces?.['articles-POS1'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
	<app-radar-link *ngIf="environment.siteTitle === 'Radar Sports'"></app-radar-link>
	<app-book-offers *ngIf="environment.optionalFeatures.includes('welcome-offers')"></app-book-offers>
    <app-legal-betting *ngIf="environment.optionalFeatures.includes('legal-betting-sidebar')"></app-legal-betting>
	<!-- <app-how-we-make-money *ngIf="environment.optionalFeatures.includes('best-books')"></app-how-we-make-money> -->
    <app-newsletter-signup-prompt *ngIf="environment.optionalFeatures.includes('newsletter')"></app-newsletter-signup-prompt>
	<app-display-ad type="sidebar-short" *ngIf="environment.googleAdsConfig?.adSpaces?.['sidebar-short'] || environment.optionalFeatures.includes('placeholder-ads')" [sportCode]="sportCode"></app-display-ad>
	<app-latest-articles-list [sportCode]="sportCode"></app-latest-articles-list>
	<app-display-ad type="articles-POS2" class="large-only sticky" [largeOnly]="true" *ngIf="environment.googleAdsConfig?.adSpaces?.['articles-POS2'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
	<app-odds-disclaimer *ngIf="environment.optionalFeatures.includes('odds-disclaimer')"></app-odds-disclaimer>
</div>
<app-adhesive-banner *ngIf="environment.optionalFeatures.includes('adhesive-banner')"></app-adhesive-banner>
